module.exports = "pegasus/assets/theme3/medium/1.jpg";